export default {
  pythonCatalogs: [
    {
      chapter: '第一章',
      name: '语法',
      desc: '学习Python基础语法，开始与其亲密接触。',
      lessons: '共15小节'
    },
    {
      chapter: '第二章',
      name: '函数',
      desc: '了解如何使用Python函数封装代码，创建一些复杂的系统',
      lessons: '共11小节'
    },
    {
      chapter: '第三章',
      name: '条件',
      desc: '学习布尔变量和逻辑运算符，并通过if、 else 和 elif 语句以及 try 和 except 语句在python中构建代码控制流',
      lessons: '共13小节'
    },
    {
      chapter: '第四章',
      name: '列表',
      desc: '列表一种线性数据结构,Python存储有序数据的利器',
      lessons: '共15小节'
    },
    {
      chapter: '第五章',
      name: '循环',
      desc: '循环可以一遍又一遍地执行Python代码，快速解决一些常见问题',
      lessons: '共11小节'
    },
    {
      chapter: '第六章',
      name: '字符串',
      desc: '深入了解Python字符串。弄清楚其如何自动创建、分配等细节。',
      lessons: '共19小节'
    },
    {
      chapter: '第七章',
      name: '模块',
      desc: '了解模块是如何在 Python 中工作的。',
      lessons: '共6小节'
    },
    {
      chapter: '第八章',
      name: '字典',
      desc: '了解有关Python 字典结构的知识，以及如何在代码中创建和使用它。',
      lessons: '共19小节'
    },
    {
      chapter: '第九章',
      name: '文件',
      desc: '学习如何用自动化的方式处理文件！通过读取和写入文本、 CSV 和 JSON 文件来研究它们的用法！',
      lessons: '共13小节'
    },
    {
      chapter: '第十章',
      name: '类',
      desc: '了解 Python中数据类型之间的差异，以及如何创建自己的类、对象和接口。',
      lessons: '共14小节'
    },
    {
      chapter: '第十一章',
      name: '函数进阶',
      desc: '充分利用Python 函数的潜力。学习声明、调用和与函数交互的不同方法！',
      lessons: '共11小节'
    }
  ],
  spiderCatalog: [
    {
      chapter: '第一章',
      name: '语言基础',
      desc: '学习回顾Python，掌握编写爬虫基础技能',
      lessons: '共9小节'
    },
    {
      chapter: '第二章',
      name: '爬虫基础',
      desc: '学习网页请求及网页解析，掌握爬虫入门必备知识',
      lessons: '共6小节'
    },
    {
      chapter: '第三章',
      name: '抓取小说',
      desc: '实战抓取网络小说',
      lessons: '共5小节'
    },
    {
      chapter: '第四章',
      name: '下载图片',
      desc: '实战批量抓取背景图',
      lessons: '共7小节'
    },
    {
      chapter: '第五章',
      name: '抓取书籍',
      desc: '实战抓取豆瓣书籍信息',
      lessons: '共5小节'
    },
    {
      chapter: '第六章',
      name: '爬虫进阶',
      desc: '爬虫高级话题，如模拟登陆、反作弊',
      lessons: '共6小节'
    },
    {
      chapter: '第七章',
      name: '爬虫框架',
      desc: '大型爬虫框架介绍scrapy',
      lessons: '共6小节'
    }
  ],
  algorithmCatalog: [
    {
      chapter: '第一章',
      name: '冒泡排序',
      desc: '最简单的排序算法，元素像"气泡"一样上浮',
      lessons: '共6小节'
    },
    {
      chapter: '第二章',
      name: '选择排序',
      desc: '最符合直觉的排序算法',
      lessons: '共3小节'
    },
    {
      chapter: '第三章',
      name: '插入排序',
      desc: '像打扑克牌时理牌过程的排序算法',
      lessons: '共3小节'
    },
    {
      chapter: '第四章',
      name: '归并排序',
      desc: '用简单的排序场景带你领略归并和递归之美',
      lessons: '共4小节'
    },
    {
      chapter: '第五章',
      name: '快速排序',
      desc: '名字里就有"快速",到底有多快',
      lessons: '共3小节'
    },
    {
      chapter: '第六章',
      name: '堆排序',
      desc: '"堆"是一个神奇的数据结构',
      lessons: '共4小节'
    },
    {
      chapter: '第七章',
      name: '计数排序',
      desc: '如何突破比较排序的极限？',
      lessons: '共3小节'
    },
    {
      chapter: '第八章',
      name: '桶排序',
      desc: '计数排序的加强版',
      lessons: '共2小节'
    }
  ]
}
